<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        title="Thông tin người dùng"
        :active="activeTab === `#${NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG}`"
        @click="
          changeCurrentTab(
            NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG,
            GIA_TRI_NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG
          )
        "
      >
        <div class="box box-form">
          <FormNguoiDung
            ref="nguoi-dung"
            :form="chiTietNguoiDung"
            :danh-sach-can-bo="danhSachCanBoLayVaoNguoiDung"
            :la-tao-moi="this.$route.params.id === 'tao-moi'"
          />
          <div class="d-flex justify-content-end">
            <base-button
              v-if="this.$route.params.id !== 'tao-moi'"
              class="btn btn-main ml-2"
              button="Lưu"
              :disabled="isLoading"
              @click="capNhatNguoiDung()"
            >
              Cập nhật
            </base-button>
            <base-button
              v-if="this.$route.params.id === 'tao-moi'"
              class="btn btn-main ml-2"
              button="Lưu"
              :disabled="isLoading"
              @click="taoMoiNguoiDung()"
            >
            </base-button>
            <base-button
              button="Làm mới"
              class="btn btn-yellow"
              @click="refreshForm('NguoiDung')"
            >
            </base-button>
<!--            <b-button-->
<!--              v-if="hasPermissionUser(PERMISSION_NAME.NGUOI_DUNG.RESET_2FA)  && chiTietNguoiDung.isUsingSecretKey2FA"-->
<!--              class="btn btn-blue"-->
<!--              @click="resetQR()"-->
<!--            >-->
<!--              <font-awesome-icon-->
<!--                icon="redo"-->
<!--                v-b-popover.hover.top="'Reset mã xác thực'"-->
<!--                class="cursor-pointer color-red"-->
<!--              />-->
<!--              Reset mã xác thực-->
<!--            </b-button>-->
            <base-button button="Đóng" class="btn btn-line" @click="boQua()">
              {{ BO_QUA_BUTTON_LABEL }}
            </base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        title="Thiết lập mật khẩu"
        :active="activeTab === `#${NGUOI_DUNG_TAB.MAT_KHAU}`"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
        @click="
          changeCurrentTab(
            NGUOI_DUNG_TAB.MAT_KHAU,
            GIA_TRI_NGUOI_DUNG_TAB.MAT_KHAU
          )
        "
      >
        <div class="box box-form">
          <QuanLyMatKhauNguoiDung
            ref="mat-khau-nguoi-dung"
            :form="chiTietNguoiDung"
            :danh-sach-can-bo="danhSachCanBoLayVaoNguoiDung"
          />
          <div class="d-flex justify-content-end">
            <base-button
              class="btn btn-main ml-2"
              :disabled="isLoading"
              @click="capNhatMatKhauNguoiDung()"
              button="Lưu"
            >
              Lưu
            </base-button>
            <base-button
              button="Làm mới"
              class="btn btn-yellow"
              @click="refreshForm('MatKhau')"
            >
            </base-button>
            <base-button button="Đóng" class="btn btn-line" @click="boQua()">
            </base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        title="Nhóm người dùng/ vai trò"
        :active="activeTab === `#${NGUOI_DUNG_TAB.VAI_TRO}`"
        @click="
          changeCurrentTab(
            NGUOI_DUNG_TAB.VAI_TRO,
            GIA_TRI_NGUOI_DUNG_TAB.VAI_TRO
          )
        "
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form">
          <div class="row mb-3">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Đơn vị - chức vụ"
                label-for="don-vi"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="(chiTietNguoiDung || {}).lstDonViChucVu"
                  :reduce="(app) => app.id"
                  label="donViChucVu"
                  v-model="
                    internalChiTietNguoiDung.userCanBoDepartmentDefaultId
                  "
                  placeholder="Đơn vị - chức vụ"
                  :clearable="false"
                  ><span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <hr />
          <div
            class="form-title mb-0 text-center text-danger"
            v-if="!chiTietNguoiDung.userCanBoDepartmentDefaultId"
          >
            <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
            Không thể chọn vai trò/ nhóm người dùng do người dùng chưa được gán
            cán bộ, hoặc cán bộ chưa thuộc đơn vị nào
          </div>
          <div v-else>
            <DanhSachVaiTroTheoNguoiDung
              ref="danhSachVaiTroTheoNguoiDung"
              :key="`role-thuoc-nguoi-dung-${
                chiTietNguoiDung &&
                chiTietNguoiDung.user &&
                chiTietNguoiDung.user.id
              }`"
              :chiTietNguoiDung="{
                ...internalChiTietNguoiDung,
                userCanBoDepartmentId:
                  internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
              }"
              :appId="internalAppId"
            />
            <div class="mt-3 mb-3">
              <hr />
            </div>
            <DanhSachGroupTheoNguoiDung
              class="mt-3"
              ref="danhSachGroupTheoNguoiDung"
              :key="`group-thuoc-nguoi-dung-${
                chiTietNguoiDung &&
                chiTietNguoiDung.user &&
                chiTietNguoiDung.user.id
              }`"
              :chiTietNguoiDung="{
                ...internalChiTietNguoiDung,
                userCanBoDepartmentId:
                  internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
              }"
              :appId="internalAppId"
            />
          </div>
        </div>
      </b-tab>
      <b-tab
        title="Phân quyền"
        :active="activeTab === `#${NGUOI_DUNG_TAB.QUYEN}`"
        @click="
          changeCurrentTab(NGUOI_DUNG_TAB.QUYEN, GIA_TRI_NGUOI_DUNG_TAB.QUYEN)
        "
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form">
          <div class="row mb-3">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Đơn vị - chức vụ"
                label-for="don-vi"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="(chiTietNguoiDung || {}).lstDonViChucVu"
                  :reduce="(app) => app.id"
                  label="donViChucVu"
                  v-model="
                    internalChiTietNguoiDung.userCanBoDepartmentDefaultId
                  "
                  placeholder="Đơn vị - chức vụ"
                  :clearable="false"
                  ><span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
          </div>
          <hr />
          <DanhSachQuyenTheoNguoiDung
            ref="danhSachQuyenTrongNguoiDung"
            :key="`danh-sach-quyen-${
              chiTietNguoiDung &&
              chiTietNguoiDung.user &&
              chiTietNguoiDung.user.id
            }`"
            :appId="internalAppId"
            :chiTietNguoiDung="{
              ...internalChiTietNguoiDung,
              userCanBoDepartmentId:
                internalChiTietNguoiDung.userCanBoDepartmentDefaultId,
            }"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  ROUTE_NAME,
  BO_QUA_BUTTON_LABEL,
  NGUOI_DUNG_TAB,
  PERMISSION_NAME,
} from "@/constants/constants";
import {
  CAP_NHAT_MAT_KHAU_NGUOI_DUNG_THANH_CONG,
  THONG_TIN_NGUOI_DUNG_DUOC_CAP_NHAT_THANH_CONG,
  THEM_NGUOI_DUNG_THANH_CONG,
} from "@/constants/message";
import FormNguoiDung from "@/components/pages/quan-tri-he-thong/nguoi-dung/FormNguoiDung";
import DanhSachVaiTroTheoNguoiDung from "@/components/pages/quan-tri-he-thong/vai-tro/DanhSachVaiTroTheoNguoiDung";
import DanhSachGroupTheoNguoiDung from "@/components/pages/quan-tri-he-thong/group/DanhSachGroupTheoNguoiDung";
import DanhSachQuyenTheoNguoiDung from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTheoNguoiDung";
import { mapGetters } from "vuex";
import { GIA_TRI_NGUOI_DUNG_TAB } from "../../../../constants/constants";
import QuanLyMatKhauNguoiDung from "./QuanLyMatKhauNguoiDung";
import { hasPermissionUser } from "@/utils/permissionUtils";

export default {
  name: "CapNhatNguoiDung",
  data() {
    return {
      PERMISSION_NAME,
      isLoading: false,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietNguoiDung: {},
      activeTab: "#thong-tin-nhom",
      NGUOI_DUNG_TAB: NGUOI_DUNG_TAB,
      GIA_TRI_NGUOI_DUNG_TAB: GIA_TRI_NGUOI_DUNG_TAB,
      disabledItem: true,
      userCanBoDepartment: null,
      internalAppId: null,
    };
  },
  components: {
    QuanLyMatKhauNguoiDung,
    FormNguoiDung,
    DanhSachVaiTroTheoNguoiDung,
    DanhSachGroupTheoNguoiDung,
    DanhSachQuyenTheoNguoiDung,
  },
  computed: {
    ...mapGetters({
      chiTietNguoiDung: "user/chiTietNguoiDung",
      danhSachCanBo: "user/danhSachCanBoLayVaoNguoiDung",
      danhSachApp: "app/tatCaApp",
      appId: "common/appId",
    }),
    danhSachCanBoLayVaoNguoiDung() {
      if (!this.danhSachCanBo) {
        return [];
      }
      let danhSach = [];
      danhSach = (this.danhSachCanBo.items || []).map((item) => {
        return {
          id: item.id,
          name: item.userName,
          ...item,
        };
      });
      return danhSach;
    },
    danhSachAppNoiBo() {
      return this.danhSachApp.filter((x) =>
        (this.internalChiTietNguoiDung.applicationIds || []).includes(x.id)
      );
    },
  },
  created() {
    this.activeTab = location.hash;
    let userId = null;
    if (this.$route.params.id !== "tao-moi") {
      userId = this.$router.currentRoute.params.id;
      this.$store.dispatch("user/layChiTietNguoiDung", {
        id: userId,
      });
    }
    this.$store
      .dispatch("user/layDanhSachCanBoVaoNguoiDung", {
        UserId: userId,
        PageIndex: 1,
        PageSize: 50,
      })
      .then(() => {});

    this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
  },
  watch: {
    chiTietNguoiDung: {
      handler() {
        this.internalChiTietNguoiDung = Object.assign(
          {},
          this.internalChiTietNguoiDung,
          this.chiTietNguoiDung
        );
        if (
          this.internalChiTietNguoiDung.applicationIds &&
          this.internalChiTietNguoiDung.applicationIds.length === 1
        ) {
          this.internalAppId = this.internalChiTietNguoiDung.applicationIds[0];
        }
      },
    },
    // appId: {
    //   handler() {
    //     this.internalAppId = this.appId;
    //   },
    //   deep: true,
    // },
    // internalAppId: {
    //   handler() {
    //     setValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID, this.internalAppId);
    //     this.$store.dispatch("common/setAppId", this.internalAppId);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    hasPermissionUser,
    resetQR() {
      this.$store
          .dispatch("user/resetQRUser", {
            userId: this.$router.currentRoute.params.id,
          })
          .then((res) => {
            if (res.data.succeeded) {
              this.$toasted.clear();
              this.$toasted.global.showSuccessMessage({
                message: "Reset mã xác thực thành công",
              });
            }
          })
          .catch(() => {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Thao tác thất bại",
            });
          });
    },
    changeCurrentTab(currentTab, giaTriCurrentTab) {
      if (this.$route.params.id === "tao-moi") {
        return;
      }
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG,
          hash: `#${currentTab}`,
          params: { item: `${giaTriCurrentTab}` },
        })
        .catch(() => {});
    },
    refreshForm(type) {
      if (type === "NguoiDung") {
        this.$refs["nguoi-dung"].refreshForm();
      } else if (type === "MatKhau") {
        this.$refs["mat-khau-nguoi-dung"].refreshForm();
      }
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG,
      });
    },
    async taoMoiNguoiDung() {
      const isValid = await this.$refs["nguoi-dung"].$refs.observer.validate();
      const $vm = this;
      let danhSachThemMoi = this.$refs["nguoi-dung"].getInternalForm();
      this.disabledItem = true;
      let payload = {
        userId: this.chiTietNguoiDung.id,
        email: danhSachThemMoi.email,
        password: danhSachThemMoi.password,
        phoneNumber: danhSachThemMoi.phoneNumber,
        userName: danhSachThemMoi.userName,
        profileId: danhSachThemMoi.profileId,
        isSystemUser: danhSachThemMoi.isSystemUser,
        isDeleted: this.isDeleted,
        applicationIds: danhSachThemMoi.applicationIds,
        roleIds: [],
        groupIds: [],
        permissionIds: [],
        canBoId: danhSachThemMoi.idCanBo,
      };
      if (isValid) {
        this.isLoading = true;
        this.$store
          .dispatch("user/taoMoiNguoiDung", payload)
          .then((response) => {
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: THEM_NGUOI_DUNG_THANH_CONG,
              });
              this.$store.dispatch("user/layChiTietNguoiDung", {
                id: response.data.data,
              });
              this.$router.push({
                path: `${ROUTE_NAME.QUAN_TRI_HE_THONG.NAME}${ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG}/${response.data.data}`,
              });
              this.changeCurrentTab(
                NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG,
                GIA_TRI_NGUOI_DUNG_TAB.THONG_TIN_NGUOI_DUNG
              );
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    async capNhatNguoiDung() {
      const isValid = await this.$refs["nguoi-dung"].$refs.observer.validate();
      const $vm = this;
      let danhSachThemMoi = this.$refs["nguoi-dung"].getInternalForm();
      this.disabledItem = true;
      let payload = {
        userId: this.chiTietNguoiDung.id,
        //email: danhSachThemMoi.email,
        password: danhSachThemMoi.password,
        //phoneNumber: danhSachThemMoi.phoneNumber,
        userName: danhSachThemMoi.userName,
        profileId: danhSachThemMoi.profileId,
        isSystemUser: danhSachThemMoi.isSystemUser,
        isDeleted: this.isDeleted,
        applicationIds: danhSachThemMoi.applicationIds,
        roleIds: [],
        groupIds: [],
        permissionIds: [],
        canBoId: danhSachThemMoi.idCanBo,
      };
      if (isValid) {
        this.isLoading = true;
        this.$store
          .dispatch("user/capNhatNguoiDung", payload)
          .then((response) => {
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: THONG_TIN_NGUOI_DUNG_DUOC_CAP_NHAT_THANH_CONG,
              });
              this.$store.dispatch("user/layChiTietNguoiDung", {
                id: this.chiTietNguoiDung.id,
              });
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    async capNhatMatKhauNguoiDung() {
      const isValid = await this.$refs[
        "mat-khau-nguoi-dung"
      ].$refs.observer.validate();
      const $vm = this;
      let matKhauCapNhat = this.$refs["mat-khau-nguoi-dung"].getInternalForm();
      this.disabledItem = true;
      let payload = {
        userName: this.chiTietNguoiDung.userName,
        password: matKhauCapNhat.newPassword,
      };
      if (isValid) {
        this.isLoading = true;
        this.$store
          .dispatch("user/capNhatMatKhauNguoiDung", payload)
          .then((response) => {
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: CAP_NHAT_MAT_KHAU_NGUOI_DUNG_THANH_CONG,
              });
            }
            this.isLoading = false;
          })
          .catch(() => {
            $vm.$toasted.global.showErrorMessage({
              message: "Cập nhật mật khẩu thất bại",
            });
            this.isLoading = false;
          });
      }
    },
  },
};
</script>


